import React from 'react';

const SummerSkills = ({ onRegisterClick }) => {
  const skillSets = [
    {
      title: "Digital Mastery",
      skills: ["Coding in 'C'", "Computer Programming", "PPT Presentations"],
      icon: "💻"
    },
    {
      title: "Mental Agility",
      skills: ["Speed Maths", "MAT (IQ) Training", "Mental Ability"],
      icon: "🧠"
    },
    {
      title: "Communication",
      skills: ["Spoken English", "Personality Development", "Public Speaking"],
      icon: "🎙️"
    },
    {
      title: "Creative Arts",
      skills: ["Calligraphy", "Creative Writing", "Artistic Design"],
      icon: "✍️"
    }
  ];

  return (
    <section className="skills-section" id="skills">
      <div className="container">
        <div className="skills-header">
          <span className="section-subtitle">21st Century Excellence</span>
          <h2 className="section-heading-dark">Beyond the Textbook</h2>
          <p className="skills-intro">
            We prepare your child for the competitive world outside the classroom 
            with specialized skill modules integrated into the summer curriculum.
          </p>
        </div>

        <div className="skills-grid">
          {skillSets.map((set, index) => (
            <div key={index} className="skill-box">
              <div className="skill-icon-wrap">{set.icon}</div>
              <h3>{set.title}</h3>
              <ul className="skill-tag-list">
                {set.skills.map((skill, i) => (
                  <li key={i} className="skill-tag">{skill}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="skills-footer-cta">
          <button className="btn-register-lg" onClick={onRegisterClick}>
            Join 2,000+ Students - Register Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default SummerSkills;